<p-inputSwitch (onChange)="handleClick($event)" [(ngModel)]="checked" classs="switch-element"></p-inputSwitch>